<template>
  <div
    v-if="data"
    class="remind_item">
    <div class="exh_image">
      <nuxt-link
        :title="`${data.aliasPrimary}${data.year}`"
        :to="`/exhibition/${data.exhibitionId || data.id}.html`"
        target="_blank">
        <NuxtImg
          :alt="data.exhibitionName"
          :src="coverImg(data.pic)"
          class="cover not-watermark"
          loading="lazy"
          rel="nofollow,noindex" />
      </nuxt-link>
      <img
        v-if="isHot"
        alt="hot"
        class="hot-icon"
        src="~/assets/icon/hot.png" />
    </div>
    <div
      class="En"
      @click="handleDetail">
      <div class="En_name">
        {{ data.exhibitionEnglishName }}
      </div>
    </div>
    <div class="name_remind">
      <i
        v-if="data.tag"
        :data-tag="data.tag"
        class="tag">
        {{ data.tag }}
      </i>
      <nuxt-link
        :title="`${data.aliasPrimary}${data.year}`"
        :to="`/exhibition/${data.exhibitionId || data.id}.html`"
        target="_blank">
        {{ data.exhibitionName }}
      </nuxt-link>
    </div>
    <div
      class="time_remind"
      @click="handleDetail">
      <time>
        <template v-if="isLogin">
          {{ data.changeTime || data.lunchTime }}
        </template>
        <template v-else>
          {{
            data.changeTime ? data.changeTime.substring(0, 7) : data.lunchTime.substring(0, 7)
          }}...
          <span
            @click.stop="clickLogin"
            style="font-size: 14px; cursor: pointer">
            {{ $t('exhibitionDetail.viewTime') }}
          </span>
        </template>
      </time>
    </div>
    <div
      class="time_remind"
      @click="handleDetail">
      <div class="hot">
        <img
          alt="hot"
          rel="nofollow,noindex"
          src="~/assets/icon/fire.png" />
        <div class="hot_num">{{ numFormat(data.hot) }}{{ $t('exhibitionDetail.view') }}</div>
      </div>
    </div>
    <div
      class="avatar_div"
      @click="handleDetail">
      <div class="avatar-list">
        <div
          v-for="item in data.exhibitionFollows.slice(0, 6)"
          class="avatar_box">
          <NuxtImg
            :alt="$t('personal.right.head_sculpture')"
            :src="`${item.avatar ? item.avatar + getXOssProcess({ w: 26, h: 26 }) : ''}`"
            :title="$t('personal.right.head_sculpture')"
            class="set-img"
            loading="lazy"
            rel="nofollow,noindex" />
        </div>
      </div>
      <div class="avatar_name">
        {{ data.exhibitionFollows.length ? data.exhibitionFollows[0].companyName : '' }}
      </div>
    </div>
    <FairTag
      :exhibition-id="data.exhibitionId || data.id"
      :tagNum="0"
      style="margin-top: 10px" />
    <div
      v-if="data.dynamic === 0"
      class="btn_remind">
      <div
        v-if="data.countDays > 0"
        class="distance">
        {{ $t('exhibition.distance') }}
        <span>{{ data.countDays }}</span>
        {{ $t('exhibition.day') }}
      </div>
      <div
        v-else-if="data.countDays === 0"
        class="distance"
        style="font-size: 14px">
        {{ $t('exhibition.openness') }}
      </div>
      <div
        v-else
        class="distance"
        style="font-size: 14px">
        {{ $t('exhibition.timeUpdate') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, defineProps } from 'vue'
  import { getXOssProcess } from '~/utils/common'
  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'

  const FairTag = defineAsyncComponent(() => import('./fairTag.vue'))

  const props = defineProps<{
    data?: any
    isHot?: boolean
    smallTag?: boolean
  }>()

  const { t } = useI18n()
  const router = useRouter()

  const handleDetail = () => {
    const text = router.resolve({
      path: `/exhibition/${props.data.exhibitionId || props.data.id}.html`
    })
    window.open(text.href, '_blank')
  }

  const coverImg = (value: string) => {
    try {
      // return getWebp(JSON.parse(value)[0])
      // parse = JSON.parse(value)[0].replace('http://', 'https://').replace(bucketHost, bucketCdnHost)
      let str = JSON.parse(value)[0]
      str = handlerReplaceImageHost(str)
      return str + getXOssWebpSize({ w: 300, h: 200 })
    } catch (e) {
      return value
    }
  }
  const globalStore = useGlobalStore()
  const isLogin = computed(() => globalStore.isLogin)
  const loginModal = computed(() => globalStore.loginModal)
  const clickLogin = () => {
    if (!isLogin.value) {
      return loginModal?.value.open()
    }
  }
</script>

<style lang="less" scoped>
  .remind_item {
    width: 288px;
    background: #fff;
    border-radius: 6px;
    padding: 17px 15px;
    margin-bottom: 12px;

    &:hover {
      .exh_image {
        .cover {
          transform: scale(1.2);
        }
      }
    }

    .exh_image {
      width: 100%;
      height: 156px;
      border-radius: 4px;
      margin: 0 auto 13px;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 258px;
        height: 156px;
        object-fit: contain;
        border-radius: 4px;
        transition: all 0.3s;
      }

      .hot-icon {
        width: 32px;
        height: 20px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .En {
      display: flex;
      margin-bottom: 8px;
      cursor: pointer;

      .En_name {
        font-size: 18px;
        font-weight: bold;
        color: @app-color;
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        a {
          color: @app-color;
        }
      }
    }

    .name_remind {
      font-size: 16px;
      color: #333;
      letter-spacing: 1px;
      margin-bottom: 5px;
      word-break: break-all;
      display: flex;
      align-items: center;

      a {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .tag {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 22px;
        font-style: normal;
        font-size: 13px;
        border-radius: 4px;
        padding: 0 4px;
        color: #fff;
        margin-right: 2px;
        text-align: center;
        cursor: pointer;
      }

      .tag[data-tag='推荐'] {
        background: linear-gradient(#ff6337, #ff381a);
      }

      .tag[data-tag='精选'] {
        background: linear-gradient(#39dd80, #1cb84a);
      }

      .tag[data-tag='热门'] {
        background: linear-gradient(#37b0fe, #1d7cfe);
      }
    }

    .time_remind {
      font-size: 16px;
      color: #333;
      margin-bottom: 5px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .hot {
        display: flex;
        align-items: center;

        img {
          height: 15px;
          width: auto;
          margin-right: 5px;
        }

        .hot_num {
          font-size: 16px;
          color: #333;
        }
      }
    }

    .avatar_div {
      display: flex;
      align-items: center;
      height: 28px;
      cursor: pointer;

      .avatar-list {
        display: flex;
        width: 130px;

        .avatar_box {
          margin-left: -8px;

          .set-img {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            object-fit: cover;
          }

          &:first-child {
            margin-left: 0;
          }
        }
      }

      .avatar_name {
        width: 100px;
        font-size: 14px;
        // flex: 1;
        text-align: center;
        overflow: hidden; /* 隐藏溢出内容 */
        text-overflow: ellipsis; /* 使用省略号表示溢出的文本 */
        white-space: nowrap; /* 防止文本换行 */
      }
    }

    .btn_remind {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .distance {
        font-size: 16px;
        color: #333;
        margin-left: auto;

        span {
          color: #ff8600;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
</style>
